// Linke Werkzeugpalette des Dacheditors.
import type { ReactNode } from "react";
import type { Tool } from "./types.js";
import {
  IconSelect,
  IconHand,
  IconRect,
  IconPolygon,
  IconRuler,
  IconAngle,
} from "./icons.js";

interface ToolPaletteProps {
  tool: Tool;
  onToolChange: (tool: Tool) => void;
  disabled?: boolean;
}

const TOOLS: Array<{ id: Tool; icon: ReactNode; label: string }> = [
  { id: "select", icon: <IconSelect />, label: "Auswählen" },
  { id: "pan", icon: <IconHand />, label: "Verschieben" },
  { id: "rect", icon: <IconRect />, label: "Rechteck" },
  { id: "polygon", icon: <IconPolygon />, label: "Polygon" },
  { id: "measure", icon: <IconRuler />, label: "Messen" },
  { id: "angle", icon: <IconAngle />, label: "Winkel" },
  { id: "edge", icon: <span style={{ fontSize: 17, fontWeight: 800, lineHeight: 1 }}>╱</span>, label: "Dachkante zeichnen" },
  { id: "keepout", icon: <span style={{ fontSize: 15, lineHeight: 1 }}>▦</span>, label: "Sperrfläche zeichnen" },
  { id: "module", icon: <span style={{ fontSize: 15, lineHeight: 1 }}>▤</span>, label: "Module ein/aus (einzelnes Modul anklicken)" },
];

export function RoofToolPalette({ tool, onToolChange, disabled }: ToolPaletteProps) {
  return (
    <div
      style={{
        width: 46,
        flexShrink: 0,
        background: "#eef2f6",
        borderRight: "1px solid #d4dde6",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        padding: "8px 0",
        gap: 3,
        opacity: disabled ? 0.5 : 1,
        pointerEvents: disabled ? "none" : "auto",
      }}
    >
      {TOOLS.map((t) => {
        const active = tool === t.id;
        return (
          <button
            key={t.id}
            type="button"
            title={t.label}
            onClick={() => onToolChange(t.id)}
            style={{
              width: 34,
              height: 34,
              borderRadius: 7,
              border: "none",
              cursor: "pointer",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              background: active ? "var(--blue-600)" : "transparent",
              color: active ? "#fff" : "#475569",
            }}
          >
            {t.icon}
          </button>
        );
      })}
    </div>
  );
}
